import React                from 'react'
import { 
    Container, 
    Content,
    Header,
    ServicesList
}                           from './component'

const Services = () => {
    return (
        <Container>
            <Header />
            <Content>
                <ServicesList />
            </Content>
        </Container>
    )
}

export default Services
